import { useSearchParams, useRouter, usePathname } from "next/navigation"
import { useCallback, useMemo } from "react"
import { TabType } from "./Tabs"

export const useTabs = ({ tabs, defaultTab }: { tabs: TabType[]; defaultTab: TabType }) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const activeTabId = searchParams?.get("tab")

  const setActiveTab = useCallback(
    (tabId: string) => {
      const current = new URLSearchParams(Array.from(searchParams?.entries() || []))

      if (!tabId) {
        current.delete("tab")
      } else {
        current.set("tab", tabId)
      }

      const search = current.toString()
      const query = search ? `?${search}` : ""

      window.history.pushState(null, "", query)
    },
    [pathname, searchParams]
  )

  const selectedTab = useMemo(() => {
    if (!activeTabId) {
      return defaultTab
    } else {
      return tabs.find(tab => tab.id === activeTabId) || defaultTab
    }
  }, [defaultTab, tabs, activeTabId])

  return {
    selectedTab,
    setActiveTab,
  }
}
